import { useQuery } from 'react-query';

import { taskApi } from 'src/Services/API';
import { RelatedEntityType } from 'src/types/task.types';

const useFetchTasksByRelatedEntity = (
  assetId: string,
  relatedEntityType: RelatedEntityType,
  relatedEntityId: string
) => {
  return useQuery(
    ['tasks', assetId, 'related', relatedEntityType, relatedEntityId],
    () => taskApi.findByRelatedEntity(assetId, relatedEntityType, relatedEntityId),
    {
      enabled: !!assetId && !!relatedEntityId,
    }
  );
};

export default useFetchTasksByRelatedEntity;
